import { PersonDetailsPanel } from '../../../components/person/PersonDetailsPanel';
import { PersonMobilisationsPanel } from '../../../components/person/PersonMobilisationsPanel';
import { PreflightPanel } from '../../../components/person/PreflightPanel';
import type { ActiveCheck, PersonApi } from './types';

export function ProfileTab({
  person,
  metadata,
  checks,
  onPersonSaved,
  onMetadataSaved,
  refreshEvents,
}: {
  person: PersonApi;
  metadata: Record<string, unknown>;
  checks: ActiveCheck[];
  onPersonSaved: (p: PersonApi) => void;
  onMetadataSaved: (meta: Record<string, unknown>) => void;
  /** Refetches the event chain after the work-email override appends one. */
  refreshEvents: () => void;
}) {
  // Existing staff (marked "not an onboarding starter", or auto-provisioned
  // as a training learner on SSO) have no pre-employment gates to clear, so
  // the checklist is noise for them and is hidden.
  const isExistingEmployee =
    metadata.onboarding_hidden === true || metadata.training_learner === true;

  return (
    <>
      <PersonDetailsPanel
        person={person}
        onSaved={onPersonSaved}
        onEmailChanged={refreshEvents}
      />
      <PersonMobilisationsPanel
        personId={person.id}
        personName={person.full_name}
      />
      {isExistingEmployee ? null : (
        <PreflightPanel
          personId={person.id}
          metadata={metadata}
          checks={checks}
          onSaved={onMetadataSaved}
        />
      )}
    </>
  );
}
